var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n\n                          direto\n                          "+_vm._s(this.$route.params.Param1)+"\n                          imprimindo dado banco fixo\n                          "+_vm._s(_vm.messages)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }